import {ExclamationTriangle} from "react-bootstrap-icons";
import { Link } from "../Link";

export function NotAdminAuthorized() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-red-50 p-4 dark:bg-slate-700">
      <div className="bg-white dark:bg-slate-500 shadow-lg rounded-lg border-2 border-red-300 p-8 max-w-md w-full text-center">
        <ExclamationTriangle className="mx-auto mb-4 text-red-500 dark:text-red-300" size={64} />
        <h2 className="text-2xl font-bold text-red-700 mb-4 dark:text-red-300">Unauthorized Access</h2>
        <p className="text-gray-600 dark:text-gray-100 mb-4">
          You do not have the necessary admin permissions to access this page. Please contact Honors IT support for the permission if you should have one <Link to="mailto:honors-it@honors.usf.edu?subject=Admin permission request for Office of National Scholars">(honors-it@honors.usf.edu)</Link>
        </p>
      </div>
    </div>
  );
}
